export default function () {
	const collapse = document.querySelectorAll( '.collapse-down' );
	collapse.forEach(
		function(el) {
			const parent = el.parentElement;
			el.addEventListener(
				'click',
				function() {
					if (parent.classList.contains( 'active' )) {
						parent.classList.remove( 'active' )
						el.innerText = 'Więcej...'
					} else {
						parent.classList.add( 'active' )
						el.innerText = 'Mniej...'
					}
				}
			)
		}
	)

}
